import { useState, useCallback } from "react";
import { locationService } from "../services/location";

export const useLocation = () => {
  const [categories, setCategories] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [dealers, setDealers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchCategories = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await locationService.getCategories();
      if (Array.isArray(response)) {
        setCategories(response);
        return response;
      } else if (
        response &&
        response.status === 1 &&
        Array.isArray(response.data)
      ) {
        setCategories(response.data);
        return response.data;
      } else {
        console.warn("Beklenmeyen kategori yanıtı yapısı:", response);
        setCategories([]);
        return [];
      }
    } catch (err) {
      setError(err.message || "Kategoriler getirilemedi");
      console.error("Kategoriler getirme hatası:", err);
      setCategories([]);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchDistricts = useCallback(async (cityId) => {
    if (!cityId) return;
    setLoading(true);
    setError(null);
    try {
      const response = await locationService.getDistricts(cityId);
      if (Array.isArray(response)) {
        setDistricts(response);
        return response;
      } else if (
        response &&
        response.status === 1 &&
        Array.isArray(response.data)
      ) {
        setDistricts(response.data);
        return response.data;
      } else {
        console.warn("Beklenmeyen ilçe yanıtı yapısı:", response);
        setDistricts([]);
        return [];
      }
    } catch (err) {
      setError(err.message || "İlçeler getirilemedi");
      console.error("İlçeler getirme hatası:", err);
      setDistricts([]);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchDealers = useCallback(async (cityId = null, districtId = null) => {
    setLoading(true);
    setError(null);
    try {
      const response = await locationService.getDealers(cityId, districtId);
      if (Array.isArray(response)) {
        setDealers(response);
        return response;
      } else if (
        response &&
        response.status === 1 &&
        Array.isArray(response.data)
      ) {
        setDealers(response.data);
        return response.data;
      } else {
        console.warn("Beklenmeyen bayi yanıtı yapısı:", response);
        setDealers([]);
        return [];
      }
    } catch (err) {
      setError(err.message || "Bayiler getirilemedi");
      console.error("Bayiler getirme hatası:", err);
      setDealers([]);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    categories,
    districts,
    dealers,
    fetchCategories,
    fetchDistricts,
    fetchDealers,
    loading,
    error,
    setCategories,
    setDistricts,
    setDealers,
  };
};

export default useLocation;
